import { format } from 'date-fns'

export default {
    reportsSummaries: [],
    reportsSummariesLoading: false,
    reportsSummariesFilters: setInitialReportsSummariesFilters(),
    setInitialReportsSummariesFilters: setInitialReportsSummariesFilters
}

function setInitialReportsSummariesFilters() {
    return {
        users_ids: null,
        productionSite_id: null,
        productionSiteGroup_id: null,
        finishDateTime__lte: format(new Date(), 'YYYY-MM-DD'),
        finishDateTime__gte: format(new Date(), 'YYYY-MM-DD'),
    }
}